import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { message, Tooltip, Row, Col } from "antd";
import dayjs from "dayjs";
import EmployeeReportFilter from "../../../components/EmployeeReportFilter";
import EmployeeReportModal from "../../../components/modelpopup/EmployeeReportModal";
import { useSelector } from "react-redux";
import { selectAdminReport, addOverrideHistory } from "../../../Slices/employeereportslice";
import { fetchAdminReport, } from "../../../Slices/employeereportslice";
import { useDispatch } from "react-redux";
import { updateAdminReport, updateMultipleWorkHistories } from "../../../Slices/employeereportslice";
import Swal from "sweetalert2";
import { setLoader } from "../../../Slices/loaderSlice";
import { AntdButton, DatePickerField, SelectInput } from "../../../blueplanitUtils/InputField";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { getOptionsByPath } from "../../../utilsdata";
import { RECORDS, TASKS } from "../../../Dropdownmanager"
import { View } from "@react-pdf/renderer";
const ClientReport = () => {
  const employees = useSelector((state) => state.loginUserInfo.allUsers);
  const location = useLocation();
  const today = dayjs();
  const currentPath = location.pathname;
  let clients = useSelector(selectAdminReport);
  const [DataForClear, SetdataForClear] = useState(clients);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [isEditingBulk, setIsEditingBulk] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [modalData, setModalData] = useState({});
  const [startingTime, setStartingTime] = useState();
  const [endingTime, setEndingTime] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

  const productiveTasks = [
    "Calling",
    "Linkedin",
    "Email",
    "Data Processing",
  ];
  const dropdownRef = useRef(null);
  const filterRef = useRef();
  const taskOptions = getOptionsByPath(
    NestedDatabucket,
    [RECORDS, TASKS]
  );

  if (currentPath === "/ClientReport") {
    clients = clients?.filter(
      (client) =>
        client.department === "Operations" || client.department === "Both"
    );


  } else if (currentPath === "/SalesReport") {
    clients = clients?.filter(
      (client) => client.department === "Sales" || client.department === "Both"
    );

  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const filteredTaskOptions = currentPath === "/ClientReport"
    ? taskOptions.filter(option => !["Calling", "Linkedin", "Data Processing"].includes(option.value))
    : taskOptions;

  const handleSync = () => {
    if (filterRef.current) {
      filterRef.current.resetForm();
    }

    dispatch(setLoader(true));
    dispatch(fetchAdminReport(filters)).then((results) => {
      dispatch(setLoader(false));
    });
  };

  const calculateDuration = (start, end) => {
    if (start && end) {

      const startDate = new Date(Number(start));
      const endDate = new Date(Number(end));
      const durationMs = endDate - startDate;

      const hours = Math.floor(durationMs / (1000 * 60 * 60));
      const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((durationMs % (1000 * 60)) / 1000);

      const time = `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      return time;
    }
    return null;
  };
  const calculateTotalDuration = () => {
    let totalSeconds = clients?.reduce((acc, client) => {
      const duration = client.duration;

      const match = duration?.match(/^(\d{2}):(\d{2}):(\d{2})$/);

      if (match) {
        const hours = parseInt(match[1]);
        const minutes = parseInt(match[2]);
        const seconds = parseInt(match[3]);
        return acc + hours * 3600 + minutes * 60 + seconds;
      }

      return acc;
    }, 0);
    const totalHours = Math.floor(totalSeconds / 3600);
    const remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
    const remainingSeconds = totalSeconds % 60;

    return `${totalHours.toString().padStart(2, "0")}:${remainingMinutes
      .toString()
      .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
  };
  const handleView = (record) => {
    setIsEdit(false);
    setModalData(record);
    setShowModal(true);
  };

  const handleEdit = (record) => {
    setIsEdit(true);
    setModalData(record);
    setShowModal(true);
  };

  const userid = loginUser?.id.toString();
  const employee = employees.find((emp) => emp.id === userid);
  const getISTRangeTimestamps = (fromDate, toDate) => {
    const istStartDate = new Date(fromDate);
    const istEndDate = new Date(toDate);
    istStartDate.setHours(0, 0, 0, 0);
    istEndDate.setHours(23, 59, 59, 999);
    const startDateUTC = new Date(istStartDate.getTime());
    const endDateUTC = new Date(istEndDate.getTime());

    const startTimestamp = startDateUTC.getTime().toString();
    const endTimestamp = endDateUTC.getTime().toString();

    return {
      startTimestamp,
      endTimestamp,
    };
  };
  const employeename = employee
    ? `${employee.firstname} ${employee.lastname}`
    : "Employee not found";

  const toggleBulkEdit = () => {
    SetdataForClear(clients)
    if (isButtonDisabled) return;
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 5000);
    if (isEditingBulk) {

      const updatedRecords = clients
        .map((client) => {
          if (client.isUpdated) {


            return {
              id: client._id,
              startTime: startingTime?.toString(),
              endTime: endingTime?.toString(),
              message: client.message,
              taskType: client.taskType,
              requestId: client.requestIds,
              updatedBy: employeename,
            };
          }
          return null;
        })
        .filter((record) => record !== null);

      if (updatedRecords.length > 0) {


        Swal.fire({
          title: "Are you sure?",
          text: "You are about to submit these changes.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, submit it!",
          cancelButtonText: "No, cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(updateMultipleWorkHistories({ updates: updatedRecords }))
              .then((res) => {
                if (res.meta.requestStatus === "fulfilled") {
                  dispatch(addOverrideHistory(res.payload));
                }
                message.success("Bulk changes have been submitted!");
                setIsEditingBulk(false);
              })
              .catch((error) => {
                message.error(`Error submitting changes: ${error.message}`);
              });

          } else {
            setIsEditingBulk(true);
          }
        });
      } else {
        message.info("No changes to submit.");
      }
    }

    setIsEditingBulk(!isEditingBulk);
  };
  const { startTimestamp, endTimestamp } = getISTRangeTimestamps(today, today);
  const filters = {

    startDateTime: startTimestamp,
    endDateTime: endTimestamp,
    reporttype: currentPath,
  };

  useEffect(() => {
    dispatch(setLoader(true));
    dispatch(fetchAdminReport(filters)).then((results) => {
      dispatch(setLoader(false));
    });
  }, [dispatch, currentPath]);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination);
  };

  const handleClear = () => {
    setIsEditingBulk(false);
    dispatch(updateAdminReport(DataForClear));
    message.info("Changes have been cleared");
  };

  const handleInlineEdit = (key, field, value) => {
    const updatedClients = clients.map((client) =>
      client._id === key
        ? {
          ...client,
          [field]: value,
          isUpdated: true,
          duration: calculateDuration(client.startTime, client.endTime),
        }
        : client
    );
    dispatch(updateAdminReport(updatedClients));
  };
  const handleDateChange = (key, field, value) => {
    const formattedDate = value ? dayjs(value).valueOf() : "";
    if (field === "startTime") {
      setStartingTime(formattedDate);
    }
    if (field === "endTime") {
      setEndingTime(formattedDate);
    }
    const timestamp = value ? dayjs(value).valueOf() : null;

    const updatedClients = clients.map((client) =>
      client._id === key
        ? { ...client, [field]: timestamp, isUpdated: true }
        : client
    );
    dispatch(updateAdminReport(updatedClients));
  };


  const handleSave = (field, value) => {
    dispatch(
      updateMultipleWorkHistories({
        id: modalData.key,
        startTime: modalData.startTime,
        endTime: modalData.endingTime,
        updatedBy: modalData.message,
        taskType: modalData.taskType,
        requestId: modalData.requestIds,
        Billable: modalData.taskType === "Email" || "Processing" ? "Yes" : "No"
      })
    )
      .then(() => {
        message.success("Record updated successfully");
        setShowModal(false);
      })
      .catch((error) => {
        message.error(`Error updating record: ${error.message}`);
      });
  };

  const handleClose = () => setShowModal(false);


  const disableFutureTime = (current) => {
    const now = dayjs();

    if (!current || current.isAfter(now, 'day')) {
      return {
        disabledHours: () => Array.from({ length: 24 }, (_, i) => i),
        disabledMinutes: () => Array.from({ length: 60 }, (_, i) => i),
        disabledSeconds: () => Array.from({ length: 60 }, (_, i) => i),
      };
    }

    if (current.isSame(now, 'day')) {
      return {
        disabledHours: () => Array.from({ length: 24 }, (_, i) => (i > now.hour() ? i : -1)).filter(i => i >= 0),
        disabledMinutes: () => Array.from({ length: 60 }, (_, i) => (i > now.minute() ? i : -1)).filter(i => i >= 0),
        disabledSeconds: () => Array.from({ length: 60 }, (_, i) => (i > now.second() ? i : -1)).filter(i => i >= 0),
      };
    }

    return {};
  };
  const columns = [
    {
      title: "",
      dataIndex: "overrideHistory",
      render: (text, record) => {
        return record?.overrideHistory?.length !== 0 ? (
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#0255CD",
              display: "inline-block",
              marginRight: "8px",
            }}
          ></span>
        ) : null;
      },
      width: 40,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      width: 180,
    },
    {
      title: "Email",
      dataIndex: "emailId",
      width: 160,
    },
    {
      title:
        filters.reporttype === "/ClientReport"
          ? "Client Name"
          : filters.reporttype === "/SalesReport"
            ? "Agency Name"
            : null,
      dataIndex:
        filters.reporttype === "/ClientReport"
          ? "clientName"
          : filters.reporttype === "/SalesReport"
            ? "agencyName"
            : null,

      render: (text, record) => {
        if (filters.reporttype === "/ClientReport") {
          return text;
        } else if (filters.reporttype === "/SalesReport") {
          return text;
        }
        return null;
      },
    },
    {
      title: filters.reporttype === "/ClientReport" ? "Service" : null,
      dataIndex: filters.reporttype === "/ClientReport" ? "service" : null,
      width: filters.reporttype === "/SalesReport" ? 0 : 100,
      render: (text, record) => {
        return filters.reporttype === "/ClientReport" ? text : null;
      },
    },
    {
      title: "Reporting To",
      dataIndex: "reportingTo",
      width: 120,
      render: (text, record) => {
        return text || "N/A";
      },
    },
    {
      title: "Task",
      dataIndex: "taskType",
      width: 90,
      render: (text, record) =>
        isEditingBulk ? (
          <div style={{ width: "150px" }}>
            <SelectInput
              value={record.taskType}
              disabled={!record.endTime}
              onChange={(value) =>
                handleInlineEdit(record._id, "taskType", value)
              }
              style={{
                border: "none",
                outline: "none",
                width: "100%",
              }}
              options={filteredTaskOptions}
            />
          </div>
        ) : (
          text
        ),
    },
    {
      title:
        filters.reporttype === "/SalesReport" ? "Type of production" : null,
      dataIndex: filters.reporttype === "/SalesReport" ? "taskType" : null,
      width: filters.reporttype === "/SalesReport" ? 150 : 20,
      render: (text, record) => {
        if (filters.reporttype === "/SalesReport") {



          if (productiveTasks.includes(record.taskType)) {
            return "Productive";
          } else {
            return "Non-Productive";
          }
        }
        return null;
      },
    },
    {
      title: filters.reporttype === "/ClientReport" ? "Billable" : null,
      dataIndex: filters.reporttype === "/ClientReport" ? "billable" : null,
      width: filters.reporttype === "/SalesReport" ? 0 : 100,
      render: (text, record) => {
        return filters.reporttype === "/ClientReport" ? text : null;
      },
    },
    {
      title: filters.reporttype === "/ClientReport" ? "Request#" : null,
      dataIndex: filters.reporttype === "/ClientReport" ? "requestIds" : null,
      width: filters.reporttype === "/SalesReport" ? 0 : 100,
      render: (text, record) => {
        return filters.reporttype === "/ClientReport" ? text : null;
      },
    },
    {
      title:
        filters.reporttype === "/ClientReport" ? "Request Completed" : null,
      dataIndex:
        filters.reporttype === "/ClientReport" ? "requestCompleted" : null,
      width: filters.reporttype === "/SalesReport" ? 0 : 100,
      sorter: (a, b) => a.requestCompleted.length - b.requestCompleted.length,
      render: (text, record) => {
        return filters.reporttype === "/ClientReport" ? text : null;
      },
    },
    {
      title: filters.reporttype === "/SalesReport" ? "Lead ID" : null,
      dataIndex: filters.reporttype === "/SalesReport" ? "requestId" : null,
      width: 40,
      render: (text, record) => {
        return filters.reporttype === "/SalesReport" ? text : null;
      },
    },
    {
      title: "Start Date & Time",
      dataIndex: "startTime",
      width: 150,
      render: (text, record) => {
        return isEditingBulk ? (
          <div style={{ width: "150px" }}>
            <DatePickerField
              disabled={!record.endTime}
              label={""}
              showTime
              value={
                dayjs(parseInt(text)).isValid()
                  ? dayjs(parseInt(text))
                  : dayjs()
              }
              format="DD/MM/YYYY hh:mm A"
              onChange={(date) => {
                if (date) {
                  handleDateChange(record._id, "startTime", date);
                }
              }}
              disabledDate={(current) => {
                return current && current > dayjs().endOf('day');
              }}
              disabledTime={disableFutureTime}
            />
          </div>
        ) : (
          dayjs(parseInt(text)).format("DD/MM/YYYY hh:mm A")
        );
      },
    },
    {
      title: "End Date & Time",
      dataIndex: "endTime",
      width: 150,
      render: (text, record) => {
        return isEditingBulk ? (
          <div style={{ width: "150px" }}>
            <DatePickerField
              disabled={!text}
              label={""}
              showTime
              value={text ? dayjs(parseInt(text)) : null}
              format="DD/MM/YYYY hh:mm A"
              onChange={(date) => {
                if (date) {
                  handleDateChange(record._id, "endTime", date);
                }
              }}
              disabledDate={(current) => {
                return current && current > dayjs().endOf('day');
              }}
            />
          </div>
        ) : text ? (
          dayjs(parseInt(text)).format("DD/MM/YYYY hh:mm A")
        ) : (
          " "
        );
      },
    },
    {
      title: "Duration",
      dataIndex: "duration",
      width: 100,
      sorter: (a, b) => a.requestId.length - b.requestId.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 100,
      sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      title: "View",
      dataIndex: "view",
      key: "view",
      width: 80,
      render: (_, record) => (
        <Link onClick={() => handleView(record)}>
          <i className="fa fa-eye"></i>
        </Link>
      ),
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      width: 100,
      render: (_, record) => (
        <Link onClick={() => handleEdit(record)}>
          <i className="fa fa-pencil"></i>
        </Link>
      ),
    },

  ];

  const PageChange = (page) => {
    setCurrentPage(page);
  };

  function formatDateTime(timestamp) {
    const date = new Date(parseInt(timestamp));
    const options = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
      timeZone: "Asia/Kolkata",
    };
    return date.toLocaleString("en-IN", options);
  }

  let rowsWithSerialNumber = [];

  if (clients && clients.length > 0) {
    rowsWithSerialNumber = clients.map((row, index) => {
      return {
        EmployeeName: row.employeeName ? row.employeeName : "  ",
        EmailId: row.emailId ? row.emailId : "  ",
        ReportingTo: row.reportingTo ? row.reportingTo : "  ",
        ClientName: row.clientName ? row.clientName : "  ",
        AgencyName: row.department === "Sales" ? row.agencyName : row.clientName,
        Service: row.service ? row.service : "  ",
        TaskType: row.taskType ? row.taskType : "  ",
        Billable: (row.taskType === 'Email' || row.taskType === 'Processing') ? 'Yes' : 'No',
        RequestId: row.requestIds ? row.requestIds : "  ",
        LeadID: row.requestIds ? row.requestIds : "  ",
        RequestCompleted: row.requestCompleted ? row.requestCompleted : "  ",
        StartTime: row.startTime ? formatDateTime(row.startTime) : "  ",
        EndTime: row.endTime ? formatDateTime(row.endTime) : "  ",
        Duration: row.duration ? row.duration : "  ",
        Status: row.status ? row.status : "  ",

        // Fields from requestFields
        Request: row?.requestId || "  ",
        "Request Type": row?.emailDetails?.[0]?.quoteType || "  ",
        "Processed By": row?.emailDetails?.[0]?.assignTo || row?.emailDetails?.[0]?.assignedTo || "  ",
        "Process Type": row?.emailDetails?.[0]?.processType || "  ",
        "No. of Quotes Received": row?.emailDetails?.[0]?.noofQuotes || "  ",
        "Request Received Date": row?.emailDetails?.[0]?.date || "  ",
        "Completed Date": row?.emailDetails?.[0]?.completedDate || "  ",
        "Due Date": row?.emailDetails?.[0]?.dueDate || "  ",
        "Start Date Override": row?.emailDetails?.[0]?.startDate || "  ",
        "Due Date Override": row?.emailDetails?.[0]?.dueDate || "  ",
        Department: row?.emailDetails?.[0]?.department || "  ",
        "Insured Name": row?.emailDetails?.[0]?.insuredName || "  ",

        Requester: row, // if needed for drill-down or modal use
        ...row, // include any remaining raw fields
        ...(row.department === "Sales"
          ? {
            TypeOfProduction: productiveTasks.includes(row.taskType)
              ? "Productive"
              : "Non productive",
          }
          : {}),
      };
    });
  }



  const simulatePrintDialog = (dataToExport, selectedColumns) => {
    const printableContent = document.createElement("div");
    printableContent.style.width = "100%";
    printableContent.style.margin = "0 auto";
    printableContent.style.padding = "5px";
    printableContent.style.fontFamily = "Arial, sans-serif";
    printableContent.style.fontSize = "5px";
    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.border = "1px solid #000";
    table.style.borderCollapse = "collapse";

    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");

    selectedColumns.forEach((col) => {
      const th = document.createElement("th");
      th.style.padding = "2px";
      th.style.textAlign = "left";
      th.style.border = "1px solid #ddd";
      th.innerText = col.toUpperCase();
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);

    const tbody = document.createElement("tbody");
    dataToExport.forEach((row) => {
      const rowElement = document.createElement("tr");
      selectedColumns.forEach((col) => {
        const td = document.createElement("td");
        td.style.padding = "2px";
        td.style.textAlign = "left";
        td.style.border = "1px solid #ddd";
        td.innerText = row[col];
        rowElement.appendChild(td);
      });
      tbody.appendChild(rowElement);
    });

    table.appendChild(tbody);
    printableContent.appendChild(table);

    const printStyle = document.createElement("style");
    printStyle.innerHTML = `
      body * {
        visibility: hidden;
      }
      #print-content, #print-content * {
        visibility: visible;
      }
      #print-content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
      }
      table {
        margin-top: 5px;
        width: 100%;
        border: 1px solid black;
        border-collapse: collapse;
      }
      th, td {
        padding: 2px;
        text-align: left;
        border: 1px solid #ddd;
      }
    `;
    document.head.appendChild(printStyle);

    printableContent.id = "print-content";
    document.body.appendChild(printableContent);

    window.print();

    document.body.removeChild(printableContent);
    document.head.removeChild(printStyle);
  };

  const generateSelectedColumns = (reportType) => {
    let selectedColumns = [
      "EmployeeName",
      "EmailId",
      "ReportingTo",
      "TaskType",
      "Duration",
      "Status",
      "StartTime",
      "EndTime",
    ];

    if (reportType === "/ClientReport") {
      selectedColumns = [
        ...selectedColumns,
        "ClientName",
        "Service",
        "Billable",
        "RequestId",
        "RequestCompleted",
        "Request Type",
        "Processed By",
        "Process Type",
        "No. of Quotes Received",
        "Request Received Date",
        "Completed Date",
        "Due Date",
        "Start Date Override",
        "Due Date Override",
        "Department",
        "Insured Name"
      ];

    } else if (reportType === "/SalesReport") {
      selectedColumns = [
        ...selectedColumns,
        "AgencyName",
        "LeadID",
      ];
    }

    return selectedColumns;
  };

  const handleExport = (fileFormat) => {
    const selectedColumns = generateSelectedColumns(filters.reporttype);

    setDropdownOpen(false);
    let dataToExport = rowsWithSerialNumber;
    if (dataToExport.length > 0) {
      if (fileFormat === "CSV") {
        const csvData = convertToCSV(dataToExport, selectedColumns);
        downloadCSV(csvData, `Report.csv`);
      } else if (fileFormat === "PDF") {
        simulatePrintDialog(dataToExport, selectedColumns);
      }
    } else {
      message.info({
        content: "No data available for export.",
        duration: 5,
        className: "custom-toast-center",
      });
    }
  };
  const convertToCSV = (responseArray, selectedColumns) => {
    if (!responseArray || responseArray.length === 0) return "";

    const headers = selectedColumns.join(",") + "\n";

    const rows = responseArray
      .map((row) => {
        return selectedColumns
          .map((column) => {
            let value = row[column];
            if (
              typeof value === "number" ||
              (typeof value === "string" && value.length > 10)
            ) {
              value = value.toString().padEnd(15, " ");
            }

            const escapedValue = ("" + value).replace(/"/g, '""');
            return `"${escapedValue}"`;
          })
          .join(",");
      })
      .join("\n");

    return headers + rows;
  };

  const downloadCSV = (csv, filename) => {
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <EmployeeReportFilter
            toggleBulkEdit={toggleBulkEdit}
            isEditingBulk={isEditingBulk}
            PageChange={PageChange}
            ref={filterRef}
          />
          <div className="row mt-20px">
            <div className="col-md-12">
              <div className="table-responsive">
                <Row justify="end" style={{ marginTop: 20, marginBottom: 10 }}>
                  <Tooltip title="Sync Now">
                    <FontAwesomeIcon
                      icon={faArrowsRotate}
                      style={{ fontSize: '24px', color: '#1890ff', cursor: 'pointer', marginRight: '7px' }}
                      onClick={handleSync}
                    />
                  </Tooltip>
                  <Col>
                    <AntdButton
                      onClick={toggleBulkEdit}
                      disabled={isButtonDisabled || clients?.length === 0}
                      type="primary"
                      style={{ marginRight: 8 }}
                      label={isEditingBulk ? "Submit" : "Edit "}
                    />
                  </Col>
                  {isEditingBulk && (
                    <Col>
                      <AntdButton
                        style={{ marginRight: 8 }}
                        onClick={handleClear}
                        label="Clear"
                      />
                    </Col>
                  )}
                  <Col>

                    <AntdButton
                      onClick={toggleDropdown}
                      type="primary"
                      label="Export"
                      disabled={clients?.length === 0}
                    />
                    {dropdownOpen && (
                      <ul
                        ref={dropdownRef}
                        className="dropdown-menu show"
                        style={{ display: "block", position: "absolute" }}
                      >
                        <li>
                          <AntdButton
                            label="CSV"
                            className="dropdown-item"
                            onClick={(e) => {
                              e.preventDefault();
                              handleExport("CSV");
                            }}
                          />
                        </li>
                        <li>
                          <AntdButton
                            label="PDF"
                            className="dropdown-item"
                            onClick={(e) => {
                              e.preventDefault();
                              handleExport("PDF");
                            }}
                          />
                        </li>
                      </ul>
                    )}

                    <style>{`
                      .dropdown-menu {
                        list-style-type: none;
                        padding: 0;
                        margin: 0;
                        position: absolute;
                        background-color: #fff;
                        border: 1px solid #ccc;
                        width: auto;
                        min-width: 100px;
                        z-index: 1;
                        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
                        right: 0;
                        top: 35px;
                      }
                      .dropdown-menu li {
                        padding: 8px;
                        cursor: pointer;
                      }
                      .dropdown-menu li:hover {
                        background-color: #f0f0f0;
                      }
                      .dropdown-menu.show {
                        max-height: 200px;
                        overflow-y: auto;
                      }
                    `}</style>
                  </Col>
                </Row>
                <CustomGridTable
                  Id="client-report-table"
                  style={{ overflowX: "auto" }}
                  columns={columns.map((col) => ({
                    ...col,
                    align: "center",
                  }))}
                  dataSource={clients}
                  rowKey="_id"
                  size="small"
                  pagination={{
                    current: currentPage,
                    pageSize: 10,
                    position: ["bottomRight"],
                    onChange: handleTableChange,
                    showQuickJumper: true,
                    showSizeChanger: false,
                  }}
                  scroll={{ x: 1000 }}
                  footer={() => (
                    <div>
                      <strong>Total Duration: </strong>{" "}
                      {calculateTotalDuration()}
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmployeeReportModal
        show={showModal}
        handleClose={handleClose}
        data={modalData}
        isEdit={isEdit}
        handleSave={handleSave}
      />
    </>
  );
};

export default ClientReport;
